<template>
  <div class="web-root">
    <div class="page-container">
      <div v-if="env.isApp" class="custom-nav-block" :style="`padding-top:${topBarHeight}px`">
        <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb">
          <template #left>
            <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          </template>
        </van-nav-bar>
      </div>
      <iframe v-if="currentDocPath" id="offical-web-iframe" scrolling="yes" :src="currentDocPath" @load="handleLoaded" />
    </div>
  </div>
</template>

<script>
import { buildPageSrc } from '@/utils/page-host.js'

export default {
  data() {
    return {
      currentDocPath: null,
      vavaPageOrigin: 'https://www.vava.chat',
      // vava是单独部署在独立服务器ip，下的根目录，无测试环境官网，永远走 www.vava.chat
      // 其他是放到了public\official_site\[包名]目录下，由 buildPageSrc 按环境拼接 host
      docPathMap: {
        echo: '/official_site/echo/index.html',
        joychat: '/official_site/joychat/index.html',
        joyu: '/official_site/joyu/index.html',
        kiko: '/official_site/kiko/index.html',
        vava: 'https://www.vava.chat/index.html',
        vibeo: '/official_site/vibeo/index.html',
        whonow: '/official_site/whonow/index.html',
      },
    }
  },
  methods: {
    initPage() {
      if (!this.packageName || !this.docPathMap[this.packageName]) return

      // vava 官网是外部独立站，无测试环境，直接用写死地址；其余包按环境拼接 host
      const path = this.docPathMap[this.packageName]
      this.currentDocPath = this.packageName === 'vava' ? path : buildPageSrc(this.packageName, path)

      this._handleIframeMsg = (e) => {
        if (e.origin !== this.vavaPageOrigin) return

        if (e.data && e.data.type === 'VAVA_START_CHAT') {
          window.location.replace(e.data.url || this.vavaPageOrigin)
        }
      }

      window.addEventListener('message', this._handleIframeMsg)
    },
    handleLoaded() {
      // 仅同源官方站包需要同步 facebook-domain-verification；vava(跨域)/echo/joychat 跳过
      const fbVerificationPackages = ['joyu', 'kiko', 'vibeo', 'whonow']
      if (!fbVerificationPackages.includes(this.packageName)) return

      try {
        // 设置facebook-domain-verification
        const iframeEle = document.getElementById('offical-web-iframe')

        if (iframeEle && iframeEle.contentWindow) {
          const metaTag = iframeEle.contentWindow.document.querySelector('meta[name="facebook-domain-verification"]')

          if (metaTag) {
            const verificationCode = metaTag.getAttribute('content')

            const meta = document.createElement('meta')

            meta.name = 'facebook-domain-verification'

            meta.content = verificationCode

            document.head.appendChild(meta)
          }
        }
      } catch (error) {
        console.log('try catch error:', error)
      }
    },
  },
  mounted() {
    this.initPage()
  },
  beforeDestroy() {
    window.removeEventListener('message', this._handleIframeMsg)
  },
}
</script>

<style lang="scss" scoped>
.web-root {
  width: 100%;
  height: 100vh;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;

  .page-container {
    box-sizing: border-box;
    background-color: #000000;
    padding: 0;
    flex: 1;
    display: flex;
    flex-direction: column;
    min-height: 0;

    #offical-web-iframe {
      flex: 1;
      width: 100%;
      height: 100%;
      display: block;
      border: none;
    }
  }
}
</style>
